import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'orion';
import orderBy from 'lodash/orderBy';
import Severity from '../sharedComponent/severity';
import Subscribers from '../sharedComponent/subscribers';
import { useAlertSchemas } from '../../contexts/alertSchemasContext';
import { cellRendererWithToolTip } from '../sharedComponent/detailsItem';

var severityCellRenderer = function severityCellRenderer(_ref) {
  var cellData = _ref.cellData;
  return /*#__PURE__*/React.createElement(Severity, {
    severity: cellData
  });
};

var subscriberCellRenderer = function subscriberCellRenderer(_ref2) {
  var cellData = _ref2.cellData;
  return /*#__PURE__*/React.createElement(Subscribers, {
    subscriberDetails: cellData
  });
};

var columns = [{
  dataKey: 'id'
}, {
  dataKey: 'name',
  label: 'Alert Type',
  width: 0,
  flexGrow: 4,
  sortable: true,
  cellRenderer: cellRendererWithToolTip
}, {
  dataKey: 'ownerService',
  label: 'Alert Category',
  width: 0,
  flexGrow: 4,
  sortable: true,
  cellRenderer: cellRendererWithToolTip
}, {
  dataKey: 'severity',
  label: 'Severity Type',
  width: 0,
  flexGrow: 4,
  cellRenderer: severityCellRenderer
}, {
  dataKey: 'subscription',
  label: 'Subscribers',
  width: 0,
  flexGrow: 4,
  cellRenderer: subscriberCellRenderer
}];

var AlertsTypeList = function AlertsTypeList(props) {
  var onAlertsTypeSelect = props.onAlertsTypeSelect;

  var _useAlertSchemas = useAlertSchemas(),
      alertSchemas = _useAlertSchemas.alertSchemas;

  var _useState = useState('name'),
      _useState2 = _slicedToArray(_useState, 2),
      sortBy = _useState2[0],
      setSortBy = _useState2[1];

  var _useState3 = useState('DESC'),
      _useState4 = _slicedToArray(_useState3, 2),
      sortDirection = _useState4[0],
      setSortDirection = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedRows = _useState6[0],
      onRowSelect = _useState6[1];

  var dataList = alertSchemas || [];

  var getOrderedData = function getOrderedData() {
    return orderBy(dataList, [function (data) {
      return data[sortBy].toString().toLowerCase();
    }], [sortDirection.toString().toLowerCase()]);
  };

  useEffect(function () {
    var _context;

    onAlertsTypeSelect(_findInstanceProperty(_context = alertSchemas || []).call(_context, function (schema) {
      return schema.id === selectedRows;
    }));
  }, [selectedRows, alertSchemas, onAlertsTypeSelect]);
  return /*#__PURE__*/React.createElement("div", {
    className: "oui-pt-3 oui-pb-4 h-100-40px"
  }, /*#__PURE__*/React.createElement(Table, {
    columnsDef: columns,
    dataList: getOrderedData(),
    multiSelect: false,
    sortBy: sortBy,
    sortDirection: sortDirection,
    sort: function sort(column, direction) {
      setSortBy(column);
      setSortDirection(direction);
    },
    selectedRows: [selectedRows],
    onRowClick: function onRowClick(event) {
      onRowSelect(event.rowData.id);
    }
  }));
};

severityCellRenderer.propTypes = {
  cellData: PropTypes.object.isRequired
};
subscriberCellRenderer.propTypes = {
  cellData: PropTypes.object.isRequired
};
AlertsTypeList.propTypes = {
  onAlertsTypeSelect: PropTypes.func.isRequired
};
export default AlertsTypeList;